import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import { useAuthStore } from './store/auth';

import './assets/main.css';

if (typeof window !== 'undefined') {
  const passiveEvents = new Set(['touchstart', 'touchmove']);
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function patchedAddEventListener(type, listener, options) {
    if (passiveEvents.has(type)) {
      if (options === undefined || typeof options === 'boolean') {
        options = { passive: true };
      } else if (typeof options === 'object' && options.passive === undefined) {
        options = { ...options, passive: true };
      }
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
const auth = useAuthStore();
auth.initialize();

app.use(router);
app.mount('#app');
